import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { InvestigationsRepository } from '../../../infrastructure/repositories/investigations.repository';

export interface DownloadInvestigationAttachmentQuery { investigationId: string; attachmentId: string; }
export interface DownloadInvestigationAttachmentResult { downloadUrl: string; }

@Injectable({ providedIn: 'root' })
export class DownloadInvestigationAttachmentUseCase {
  private readonly _repository = inject(InvestigationsRepository);

  public execute(query: DownloadInvestigationAttachmentQuery): Observable<DownloadInvestigationAttachmentResult> {
    return this._repository.getAttachmentDownloadUrl(query.investigationId, query.attachmentId).pipe(
      map((downloadUrl) => ({ downloadUrl })),
    );
  }
}
